import React, { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns';
import haxios from '../lib/haxios';
import * as Tooltip from '@radix-ui/react-tooltip';
import { RotateCw } from 'lucide-react';
import { GlobalContext } from '../context/GlobalContext';

const VisitNotesList = () => {
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lastUpdated, setLastUpdated] = useState(new Date());
    const { uinfo } = useContext(GlobalContext);


    const fetchNotes = async () => {
        setLoading(true);
        try {
            const params = {};

            if (uinfo.Status !== 'admin') {
                params.rep = uinfo.Inits;
            }

            const response = await haxios.get('/visiondashboard/visitnotes', { params });

            console.info('Visit notes:', response.data);
            setNotes(response.data);
            setLastUpdated(new Date());
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotes();
        const interval = setInterval(fetchNotes, 30000);
        return () => clearInterval(interval);
    }, []);

    if (loading && !notes.length) {
        return <div className="w-full p-4 text-center">Loading visit notes...</div>;
    }

    if (!notes?.length) {
        return <div className="w-full p-4 text-center text-gray-500">No visit notes found</div>;
    }

    return (
        <Tooltip.Provider>
            <div className="w-full bg-white rounded-lg shadow">
                <div className="flex justify-between items-center px-4 py-3" style={{ backgroundColor: 'forestgreen', color: 'white', borderTopLeftRadius: '7px', borderTopRightRadius: '7px' }}>
                    <h2 className="font-bold">LATEST REP VISITS</h2>
                    <div className="flex items-center gap-4 text-sm text-gray-500">
                        <span style={{ color: 'lightgrey' }}>Last updated: {format(lastUpdated, 'HH:mm:ss')}</span>
                        <button
                            onClick={fetchNotes}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                            aria-label="Refresh visit notes"
                            disabled={loading}
                        >
                            <RotateCw style={{ color: 'lightgrey' }} className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-4 p-3 text-sm font-semibold bg-gray-100 rounded-t-lg">
                    <div className="col-span-2">Account</div>
                    <div className="col-span-3">Name</div>
                    <div className="col-span-2">Created By</div>
                    <div className="col-span-2">Visit Date</div>
                    <div className="col-span-3">Note</div>
                </div>

                <div className="max-h-96 overflow-y-auto">
                    {notes.map((note) => (
                        <Tooltip.Root key={note.note_id}>
                            <Tooltip.Trigger asChild>
                                <div className="grid grid-cols-12 gap-4 p-3 text-sm hover:bg-gray-50 border-b cursor-pointer">
                                    <div className="col-span-2 truncate">{note.account}</div>
                                    <div className="col-span-3 truncate">{note.customer_name}</div>
                                    <div className="col-span-2">{note.created_by}</div>
                                    <div className="col-span-2">
                                        {format(new Date(note.visit_datetime), 'dd/MM/yy HH:mm')}
                                    </div>
                                    <div className="col-span-3 truncate">{note.note_text}</div>
                                </div>
                            </Tooltip.Trigger>
                            <Tooltip.Content
                                className="bg-white p-4 rounded-lg shadow-lg border z-50 w-80"
                                side="right"
                            >
                                <div className="space-y-2">
                                    <div><span className="font-semibold">Account:</span> {note.account}</div>
                                    <div><span className="font-semibold">Customer:</span> {note.customer_name}</div>
                                    <div><span className="font-semibold">Created By:</span> {note.created_by}</div>
                                    <div>
                                        <span className="font-semibold">Visit Date:</span>{' '}
                                        {format(new Date(note.visit_datetime), 'dd/MM/yyyy HH:mm')}
                                    </div>
                                    <div>
                                        <span className="font-semibold">Note:</span>
                                        <p className="mt-1 whitespace-pre-wrap">{note.note_text}</p>
                                    </div>
                                </div>
                                <Tooltip.Arrow className="fill-white" />
                            </Tooltip.Content>
                        </Tooltip.Root>
                    ))}
                </div>
            </div>
        </Tooltip.Provider>
    );
};

export default VisitNotesList;